class StaggeredGrid extends HTMLElement {
  constructor () {
    super()

    this.slidesEl = this.querySelector('[data-el="staggered-grid.slides"]')
    this.slideEls = this.querySelectorAll('[data-el="staggered-grid.slide"]')
    this.scrollerEl = this.querySelector('[data-el="staggered-grid.scroller"]')

    // Only initialize carousel if we have slides and are on mobile
    if (this.slideEls.length < 2) return

    // Initialize carousel on mobile only
    this.initializeOnMobile()

    // Handle resize events to initialize/destroy carousel based on viewport
    window.addEventListener('resize', this.handleResize.bind(this))
  }

  initializeOnMobile () {
    if (window.innerWidth < 768) {
      if (!this.carousel) {
        this.carousel = this.initialiseCarousel()
      }
    } else {
      if (this.carousel) {
        this.carousel.destroy()
        this.carousel = null
        this.slideEls.forEach(slide => {
          slide.removeAttribute('style')
        })
      }
    }
  }

  handleResize () {
    this.initializeOnMobile()
  }

  initialiseCarousel () {
    // eslint-disable-next-line new-cap
    return new window.KeenSlider551(this.slidesEl, {
      slides: this.slideEls,
      slidesPerView: 1.2,
      spacing: 0,
      rubberband: false
    })
  }
}

customElements.define('staggered-grid', StaggeredGrid)
